var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vueprof"},[_c('the-header'),_c('div',{staticClass:"page"},[_c('h2',[_vm._v("Bonjour prof !")]),_c('img',{staticClass:"laMadame",attrs:{"src":require("../../assets/teacher.svg")}}),_c('les-boutons')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }